<script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useMapUIStore } from "@/stores/MapUIStore";
  import { useSharedShape } from '@/composables/useSharedShape.js';
  import MapDrawingToolbar from '@/components/MapDrawingToolbar.vue';
  import MapDrawingController from '@/components/MapDrawingController.vue';

  const props = defineProps({
    isSmallDevice: {
      type: Boolean,
      required: true
    }
  });  

  const mapUIStore = useMapUIStore();

  const { sharedShape } = useSharedShape();
  
  const showDrawingTools = computed(() => mapUIStore.showDrawingTools || sharedShape.value);
</script>

<template>
    <MapDrawingToolbar v-if="showDrawingTools" :isSmallDevice="props.isSmallDevice" />
    <MapDrawingController v-if="showDrawingTools" />
</template>